import React, { useEffect } from 'react';
import {
	Container,
	SpaceBetween,
	FlashbarProps,
} from '@amzn/awsui-components-console';
import { useFormContext } from 'react-hook-form';

import GenericWizard from 'src/components/commonComponents/GenericWizard/GenericWizard';
import { generateReviewSectionsFromSteps } from 'src/components/commonComponents/GenericWizard/utils/wizardUtils';

import {
	OperationProfileFormMetadata,
	getOperationWizardSteps,
} from '../AddOperation/OperationFormGenerationUtils';

interface EditOperationPageFormProps {
	onCancel: () => void;
	onSubmit: (data: OperationProfileFormMetadata) => void;
	operationName: string | null;
	isLoading: boolean;
	error?: string | null;
	flashBarItems?: FlashbarProps.MessageDefinition[];
}

export default function EditOperationPageForm({
	onCancel,
	onSubmit,
	operationName,
	isLoading,
	error,
	flashBarItems,
}: EditOperationPageFormProps) {
	const { watch, setValue } = useFormContext<OperationProfileFormMetadata>();
	const useServiceNamespaceAsOperationNamespace = watch('useServiceNamespaceAsOperationNamespace');
	const serviceNamespace = watch('serviceNamespace');

	useEffect(() => {
		if (useServiceNamespaceAsOperationNamespace === 'true') {
			setValue('operationNamespace', serviceNamespace);
		}
	}, [useServiceNamespaceAsOperationNamespace, serviceNamespace, setValue]);

	return (
		<GenericWizard<OperationProfileFormMetadata>
			title="Edit Operation"
			description="Update operation details and configuration"
			steps={getOperationWizardSteps({ useServiceNamespaceAsOperationNamespace, serviceNamespace })}
			onCancel={onCancel}
			onSubmit={onSubmit}
			isLoading={isLoading}
			errorMessage={error}
			flashBarItems={flashBarItems}
			reviewTitle="Review Operation Changes"
			submitButtonText="Save Changes"
			generateReviewSections={generateReviewSectionsFromSteps}
			additionalContent={
				<Container>
					<SpaceBetween size="s">
						<div>Operation: {operationName || 'Unknown'}</div>
					</SpaceBetween>
				</Container>
			}
		/>
	);
}
